module.exports = __webpack_public_path__ + "static/img/about-bg-blue.e58a128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-bg-blue.png
// module id = rYYn
// module chunks = 0